import React, { Suspense, lazy } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import BrandLoader from '../components/Brand/BrandLoader';
import { BackIcon } from '../components/Brand/Icon';
import './DrawingEditor.scss';

const Editor = lazy(() => import('./DrawingEditor'));
class DrawingBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() { return this.state.failed ? this.props.fallback : this.props.children; }
}
export default function DrawingDialog(props) {
  const { t } = useTranslation();
  const fallback = (failed = false) => <section className="drawing-editor app-safe-layout" role="dialog" aria-modal="true" aria-label={t('drawing:title')}>
    <header className="drawing-editor__header"><button type="button" aria-label={t('drawing:back')} onClick={props.onClose}><BackIcon /></button></header>
    {failed ? <p className="drawing-editor__notice" role="alert">{t('drawing:loadError')}</p> : <BrandLoader label={t('drawing:loading')} />}
  </section>;
  return createPortal(<div><DrawingBoundary fallback={fallback(true)}>
    <Suspense fallback={fallback()}><Editor {...props} /></Suspense>
  </DrawingBoundary></div>, document.body);
}
